/* unplugin-vue-components disabled */import { render } from "./user-message.vue?vue&type=template&id=5db64230&scoped=true"
import script from "./user-message.vue?vue&type=script&lang=js"
export * from "./user-message.vue?vue&type=script&lang=js"

import "./user-message.vue?vue&type=style&index=0&id=5db64230&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db64230"],['__file',"src/components/ai-chat-v2/user-message.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5db64230"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5db64230', __exports__)) {
    api.reload('5db64230', __exports__)
  }
  
  module.hot.accept("./user-message.vue?vue&type=template&id=5db64230&scoped=true", () => {
    api.rerender('5db64230', render)
  })

}


export default __exports__